import { Page } from './../../shared/models/page';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RequestOptions, Headers, Response } from '@angular/http';
import { List } from 'immutable';
import { Rsvp } from '../models/rsvp';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { AppAuthHttpService } from '../../http/app.auth.http.service';

@Injectable()
export class RsvpHttpService {

  private eventsUrl: string = this.environment.baseUrl + '/api/events';

  constructor(private http: AppAuthHttpService,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
  }

  getRsvps(eventId: number): Observable<List<Rsvp> | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/rsvps`)
      .map(response => List<Rsvp>(response.json().map(rsvpObject => new Rsvp(rsvpObject))))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getRsvpsByParty(eventId: number, eventPartyId: number): Observable<List<Rsvp> | Response> {
    return this.http.get(`${this.eventsUrl}/${eventId}/${eventPartyId}/rsvps`)
      .map(response => List<Rsvp>(response.json().map(rsvpObject => new Rsvp(rsvpObject))))
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  getRsvpsPaginated(eventId: number, page: number, size: number): Observable<Response | Page<Rsvp>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/rsvps?page=${page}&size=${size}`)
      .map(response => {
        let rsvpPage = response.json();
        rsvpPage.content = List<Rsvp>(rsvpPage.content);
        return rsvpPage as Page<Rsvp>;
      })
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  getRsvpsByVendorPaginated(eventId: number, eventPartyId: number, page: number, size: number): Observable<Response | Page<Rsvp>> {
    return this.http.get(`${this.eventsUrl}/${eventId}/${eventPartyId}/rsvps/paginated?page=${page}&size=${size}`)
      .map(response => {
        let rsvpPage = response.json();
        rsvpPage.content = List<Rsvp>(rsvpPage.content);
        return rsvpPage as Page<Rsvp>;
      })
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

  add(rsvp: Rsvp): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const rsvpAsJSON = JSON.stringify(rsvp.toJS());
    return this.http.post(`${this.eventsUrl}/rsvps`, rsvpAsJSON, options)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  delete(rsvp: Rsvp): Observable<any> {
    return this.http.delete(`${this.eventsUrl}/rsvps/${rsvp.eventRsvpId}`)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  update(rsvp: Rsvp): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });
    const rsvpAsJSON = JSON.stringify(rsvp.toJS());
    return this.http.put(`${this.eventsUrl}/rsvps`, rsvpAsJSON, options)
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  importRsvpFile(eventId: number, eventPartyId: number, file: File): Observable<any> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${this.eventsUrl}/${eventId}/${eventPartyId}/rsvps/bulk`, formData)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response))
      .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/rsvp.http.service.ts